import { useQuery } from "react-query";
import { CompCodeService } from "./compCode.service";

export const useFetchCompCode = () => {
    return useQuery("CompanyCodeData", () => CompCodeService.getCompCodes(), { staleTime: Infinity })
}